import { SkeletonBlock, SkeletonChip, SkeletonRow, SkeletonStack } from "@health/ui";

export function MeducationWidgetSkeleton() {
  return (
    <SkeletonStack>
      <SkeletonRow>
        <SkeletonBlock className="h-[300px] max-w-xs" />
      </SkeletonRow>
      <SkeletonChip />
    </SkeletonStack>
  );
}
